import { ENGLISH_US, FRENCH_FRANCE, SPANISH_SPAIN, GERMAN_GERMANY, CHINESE_SIMPLIFIED, BRAZILIAN_PORTUGUESE, CHINESE_TRADITIONAL, ITALIAN_ITALY, JAPANESE_JAPAN, INDONESIAN_INDONESIA, KOREAN_KOREA, RUSSIAN_RUSSIA, CZECH_CZECHIA, DUTCH_NETHERLANDS, HUNGARIAN_HUNGARY, PORTUGUESE_PORTUGAL, POLISH_POLAND, SWEDISH_SWEDEN, TURKISH_TURKEY } from './constants.mjs';

const LANGUAGES = [
  { code: ENGLISH_US, name: "English" },
  { code: FRENCH_FRANCE, name: "Fran\xE7ais" },
  { code: SPANISH_SPAIN, name: "Espa\xF1ol" },
  { code: GERMAN_GERMANY, name: "Deutsch" },
  { code: CHINESE_SIMPLIFIED, name: "\u4E2D\u6587\uFF08\u7B80\u4F53\uFF09" },
  { code: BRAZILIAN_PORTUGUESE, name: "Portugu\xEAs Brasileiro" },
  { code: CHINESE_TRADITIONAL, name: "\u4E2D\u6587\uFF08\u7E41\u9AD4\uFF09" },
  { code: ITALIAN_ITALY, name: "Italiano" },
  { code: JAPANESE_JAPAN, name: "\u65E5\u672C\u8A9E" },
  { code: INDONESIAN_INDONESIA, name: "Bahasa Indonesia" },
  { code: KOREAN_KOREA, name: "\uD55C\uAD6D\uC5B4" },
  { code: RUSSIAN_RUSSIA, name: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439" },
  { code: CZECH_CZECHIA, name: "\u010Ce\u0161tina" },
  { code: DUTCH_NETHERLANDS, name: "Nederlands" },
  { code: HUNGARIAN_HUNGARY, name: "Magyar" },
  { code: PORTUGUESE_PORTUGAL, name: "Portugu\xEAs" },
  { code: POLISH_POLAND, name: "Polski" },
  { code: SWEDISH_SWEDEN, name: "Svenska" },
  { code: TURKISH_TURKEY, name: "T\xFCrk\xE7e" }
];

export { LANGUAGES };
//# sourceMappingURL=languages.mjs.map
